import { render } from "./CampaignCategoryManageCreateForm.vue?vue&type=template&id=3b240d45&lang=true"
import script from "./CampaignCategoryManageCreateForm.vue?vue&type=script&lang=js"
export * from "./CampaignCategoryManageCreateForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__